import { ref } from 'vue'

export const showPrivacyPolicyModalBus = ref(false)
